import * as actionTypes from '../actions/actionsTypes';
import { updateObject } from '../../utils/common';

const initialState = {
    addNewAccountToUsers: '',
};

const setAddNewAccountToUsers = (state, action) => {
  return updateObject(state, {
    addNewAccountToUsers: action.data,
  });
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SETDEFAULTADDNEWACCOUNT:
      return setAddNewAccountToUsers(state, action);
    default:
      return state;
  }
};

export default reducer;
